module.exports = __webpack_public_path__ + "img/renjani_maritim.32396037.png";